import React from 'react'

import { AcornsIcon } from '@acorns/icons'

import { ProductKey, TierKey } from 'generated/types'

const INVEST = {
  product: ProductKey.Invest,
  name: 'Invest',
  slogan: 'for your future',
  icon: <AcornsIcon icon={AcornsIcon.Icon.Invest} />,
  description: [
    'Put your spare change to work with Round-Ups®',
    'Earn bonus investments from our 350+ Found Money partners',
    'Grow your knowledge with expert money tips, powered by CNBC',
  ],
}

const LATER = {
  product: ProductKey.Later,
  name: 'Later',
  slogan: 'starts today',
  icon: <AcornsIcon icon={AcornsIcon.Icon.Later} />,
  description: [
    'Get your own retirement account in under 3 minutes',
    'Earn tax advantages',
    'Updated regularly to match your goals',
  ],
}

const SPEND = {
  product: ProductKey.Spend,
  name: 'Bank',
  slogan: 'smarter',
  icon: <AcornsIcon icon={AcornsIcon.Icon.Spend} />,
  description: [
    'Instantly invest your spare change and save for later with connected investment and retirement accounts',
    'Save money with no minimum-balance or overdraft fees, and over 55,000 fee-free ATMs within the AllPoint Network',
  ],
}

const EARLY = {
  product: ProductKey.Early,
  name: 'Early',
  slogan: 'investors',
  icon: <AcornsIcon icon={AcornsIcon.Icon.ProductEarlyGreen} />,
  description: [
    'Open an investment account for kids in under 3 minutes',
    'Easily transfer the account to the child later',
  ],
}

const BRONZE = {
  name: TierKey.Bronze,
  topCopy:
    'Your diversified investment account. Invest spare change, earn bonus investments, and get financial literacy at your fingertips.',
}

const SILVER = {
  name: TierKey.Silver,
  topCopy:
    'Your personal money management system, featuring all-in-one investment, retirement, and checking accounts — plus much more.',
}

const GOLD = {
  name: TierKey.Gold,
  topCopy:
    'Investment accounts for each child in your life. Plus personal investment, retirement, and checking accounts — and much more.',
}

const TIERS = [BRONZE, SILVER, GOLD]
const PRODUCTS = [INVEST, LATER, SPEND, EARLY]

export { TIERS, PRODUCTS }
